import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: #222429;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  width: 100%;
`

export const Button = styled.div`
  border: 1px solid #2d3036;
  border-radius: 12px;
  cursor: pointer;
  margin: 0 10px;
  padding: 12px 15px;
`

export const BadgeLabel = styled.div`
  background-color: #2d3036;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 400;
  height: 100%;
  margin: auto;
  padding: 15px 60px;
  text-align: center;
  width: 100%;
`

export const BadgeTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
`

export const BadgePrice = styled.div`
  color: #d06cff;
  font-size: 14px;
  font-weight: 500;
  padding-top: 15px;
`

export const BuyButton = styled.div`
  background-color: #804cee;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  margin-top: 20px;
  outline: none;
  padding: 10px 30px;
  width: 100%;
`

export const BadgeInput = styled.input`
  background-color: #2d3036;
  border: none;
  border-radius: 12px;
  outline: none;
  padding: 15px;
  text-align: center;
  width: 100%;
`

export const AmountInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`

export const BadgeHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-left: 10px;
`
